import { AttributeValue } from "../../../library-js/dom-tools/AttributeValue";
import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { ElementSelector } from "../../../library-js/dom-tools/ElementSelector";
import { OnChange, OnClick, OnInput, OnKeyUp } from "../../../library-js/dom-tools/EventListeners";
import { URLHash } from "../../../library-js/dom/URLHash";
import { RegexValidator } from "../../../library-js/validators/RegexValidator";
import { EmailValidator } from "../../../library-js/validators/EmailValidator";
import { HTMLEditor } from "../../../library-js/dom-tools/HTMLEditor";
import { Rokojori } from "../Rokojori";
import { UserSignUpRequest } from "../../../library-js/php/user/UserSignUpRequest";
import { UserAccountCreationInput, UserCreateAccountRequest } from "../../../library-js/php/user/UserCreateAccountRequest";
import { UserAccountBlock } from "./UserAccountBlock";
import { Overlay } from "../overlay/Overlay";
import { PageHandler } from "../../../library-js/dom-tools/PageHandler";
import { UserLocales } from "../i8/UserLocales";
import { TimePin } from "../../../library-js/animation/TimePin";

class ChangePasswordData
{
  email:string;
  tokenID:string;
  password:string;  
  

  get passwordIsValud()
  {
    return this.password.length > 8;
  }
  get valid()
  {
    return this.passwordIsValud;
  }
}
export class ChangePasswordUI
{
  static readonly attribute = new ElementAttribute( "change-password" );
  static readonly selector = new ElementSelector( UserAccountBlock.type, ChangePasswordUI.attribute );

  static readonly invalidInput = new ClassFlag( "invalid-input" );
  static readonly validInput = new ClassFlag( "valid-input" );

  static readonly successContent = new ElementType( "success-content" );
  static readonly errorContent   = new ElementType( "error-content" );

  private static _data = new Map<HTMLElement,ChangePasswordData>();

  static applyOnDocument()
  {
    ChangePasswordUI._data.clear();
    ChangePasswordUI.selector.forAllInDoc( e => ChangePasswordUI.applyOnElement( e ) );
  }

  static isValidHash()
  {
    let hash = URLHash.get();

    if ( hash == null )
    {
      return false;
    }

    let firstAt = hash.indexOf( "@" );

    if ( firstAt == -1 || firstAt == 0)
    {
      return false;
    }

    let id =  hash.substring( 0, firstAt );
    let email = hash.substring( firstAt + 1 );

    console.log( "Validating:", { id, email } );
    
    if ( ! RegexValidator.BASE64URL.validate( id ) )
    {
      console.log( "ID not valid");
      return false;
    }

    console.log( "ID valid");

    if ( EmailValidator.isValid( email ) )
    {
      console.log( "EMAIL not valid" );
      return false;
    }

    console.log( "EMAIL valid");

    return true;
  }

  static getEmailAndID()
  {
    let hash = URLHash.get();
    let firstAt = hash.indexOf( "@" );
    
    let id =  hash.substring( 0, firstAt );

    let email = hash.substring( firstAt + 1 );

    return { id, email };
  }

  

  static applyOnElement( e:HTMLElement )
  {
    if ( ! ChangePasswordUI.isValidHash() )
    {
      ClassFlag.hidden.set( UserAccountBlock.inputBlock.query( e ) );
      ClassFlag.hidden.removeFrom( UserAccountBlock.invalidState.query( e ) );
      return;
    } 

    ClassFlag.hidden.removeFrom( UserAccountBlock.inputBlock.query( e ) );
    
    let { id, email } = ChangePasswordUI.getEmailAndID(); 
    
    let data = new ChangePasswordData();
    data.tokenID = id;
    data.email = email;
    data.password = "";

    ChangePasswordUI._data.set( e, data );

    let inputs = ElementType.input.queryAll( e );

    let emailInput = UserAccountBlock.emailInput.find( inputs ) as HTMLInputElement;
    let nameInput  = UserAccountBlock.nameInput.find( inputs ) as HTMLInputElement;
    let pwInput    = UserAccountBlock.pwInput.find( inputs ) as HTMLInputElement; 

    UserAccountBlock.setInputFieldState( emailInput, true );
    UserAccountBlock.setReadonlyState( emailInput, true );

    emailInput.value = email;

    let userButton = UserAccountBlock.userButton.query( e ) as HTMLElement; 

    let checkInputs = () => 
    {
      console.log( "checking input" );
      data.password = pwInput.value;
      
      ClassFlag.enabled.setAs( userButton, data.valid );

      let messageAttribute = data.valid ? ChangePasswordUI.validInput : ChangePasswordUI.invalidInput;
      
      UserAccountBlock.setValidationMessage( e, messageAttribute );

      UserAccountBlock.setInputFieldState( pwInput, data.passwordIsValud );

    };


    this.attachInputListeners( nameInput, checkInputs );
    this.attachInputListeners( pwInput, checkInputs );

    checkInputs();

    
    let anchor = ElementType.anchor.getParent( userButton );
    PageHandler.setFunctionHandleLink( anchor, Rokojori.locale( UserLocales.changePasswordButtonLinkInfo ),
      async ()=>
      { 
        console.log( "creating account", data );
        let tokenID  = data.tokenID;
        let email    = data.email;
        let password = data.password;

        let pin = TimePin.create(); 

        Rokojori.$.showLoaderScreen( UserLocales.changePasswordLoaderScreenInfo );

        let response = await Rokojori.$._oldPHPUser.changePassword( tokenID, email, password );

        await pin.forMS( 1000 );        
        Rokojori.$.hideLoaderScreen();
        
        let overlayContent:Element = null;

        if ( response.error )
        {
          overlayContent = ChangePasswordUI.errorContent.query( e );
        }
        else
        {
          overlayContent = ChangePasswordUI.successContent.query( e );
        }

        Overlay.show( overlayContent.cloneNode( true ) as HTMLElement );

        console.log( response );
        
      }
    );
    
  }

  static attachInputListeners( inputElement:HTMLInputElement, validator:()=>void )
  {
    OnChange.add( inputElement, validator );
    OnInput.add( inputElement, validator );

    UserAccountBlock.blurOnEnter( inputElement );
  }


}